import { Divider, Grid, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Input,
  InputAuto,
  InputDate,
  MultiSelect,
} from "../../controls";
import { DropLi, Model, UseForm } from "../../hooks";
import { Alert, Form, Tabs } from "../../layout";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import { NestedFormData, RmvEmptyProp } from "../../hooks/Method";
import { useTranslation } from "react-i18next";

const AddEditMM = (props) => {
  const { fromMember = false } = props;
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const { MeasMdl } = Model();
  const { Healths } = DropLi();

  const { values, setValues, errors, setErrors, handleInpChg, handleInpDate } =
    UseForm(MeasMdl);
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const { branch, authUser } = useContext(AppContext);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    if (id && !fromMember)
      API(endpoints.Meas + actions.GetById).getById(id, (res) => {
        if (res && res.status === 200) {
          var val = res.result;
          setValues((x) => ({
            ...x,
            ...RmvEmptyProp(val),
            healths: val.healths.map((j) => j.issues),
          }));
        }
      });
    else if (id && fromMember) {
      var _member = members.find((j) => j.id === parseInt(id));
      _member && setValues((j) => ({ ...j, memberId: _member.id }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, members]);

  useEffect(() => {
    if (branch && branch.id) {
      API(endpoints.Member + actions.GetAllByBranch).getById(
        branch.id,
        (res) =>
          res &&
          res.status === 200 &&
          setMembers([
            ...res.result.map((j) => ({
              ...j,
              label: j.firstName + " " + j.lastName,
            })),
          ])
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  const validateForm = () => {
    let temp = {};
    temp.date = values.date !== "" ? "" : t("ValDate");
    temp.memberId = values.memberId !== "" ? "" : t("ValMember");
    temp.height = values.height !== "" ? "" : t("ValHeight");
    temp.weight = values.weight !== "" ? "" : t("ValWeight");
    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res && (res.status === 201 || res.status === 200)) {
          setAlert({
            isOpen: true,
            type: "success",
            title: t("Success"),
            subTitle: t("MMAddTitle"),
            onClick: () => navigate("/measurements"),
          });
        } else if (res)
          setAlert({
            isOpen: true,
            type: "error",
            title: t("Error"),
            subTitle: res.msg,
          });
      };
      if (values.healths.length > 0) {
        values.healths = values.healths.map((j) => {
          return {
            issues: j,
          };
        });
      } else {
        values.healths = [];
      }
      if (values.id === 0) {
        values.branchId = branch.id;
        values.orgId = branch.orgId;
        values.addedUserId = authUser.id;
        API(endpoints.Meas + actions.Post).post(
          NestedFormData(RmvEmptyProp(values)),
          onComplete
        );
      } else
        API(endpoints.Meas + actions.Put).put(
          NestedFormData(RmvEmptyProp(values)),
          onComplete
        );
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper>
          <div className="mb-10 d-flex j-between a-center pt-15 pl-15 pr-15">
            <div>
              <h1
                variant="h5"
                className="form-title mb-5 fw-4 gray-color tx-upp
                    border-left"
              >
                {id ? t("Edit") : t("Add")} {t("Measurement")}
              </h1>
            </div>

            <div>
              <Button type="submit" loading={loading}>
                {id ? t("SaveChanges") : t("Submit")}
              </Button>
            </div>
          </div>
          <Divider className="mb-20" />
          <div className="pl-15 pr-15 pb-15">
            <Tabs
              header={[
                { label: t("GeneralFields"), icon: "" },
                { label: t("AdditionalFields"), icon: "" },
              ]}
            >
              <Grid container spacing={2.5}>
                <Grid item xs={12} md={3}>
                  <InputAuto
                    label={t("Member")}
                    name="memberId"
                    required={true}
                    value={values.memberId}
                    error={errors.memberId}
                    disabled={fromMember ? true : false}
                    onChange={handleInpChg}
                    options={members}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <InputDate
                    label={t("Date")}
                    name="date"
                    value={values.date}
                    error={errors.date}
                    required={true}
                    onChange={(date) =>
                      handleInpDate("date", new Date(date).toLocaleDateString())
                    }
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("Height")}
                    name="height"
                    value={values.height}
                    error={errors.height}
                    type="number"
                    placeholder="0.00 feet"
                    required={true}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("Height")}
                    name="weight"
                    value={values.weight}
                    error={errors.weight}
                    type="number"
                    placeholder="0.00 kg"
                    required={true}
                    onChange={handleInpChg}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2.5}>
                <Grid item xs={12} md={3}>
                  <Input
                    label={`${t("LeanMuscle")} (%)`}
                    name="leanMuscle"
                    type="number"
                    placeholder="0.00 %"
                    value={values.leanMuscle}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("Neck")}
                    name="neck"
                    type="number"
                    placeholder="0.00"
                    value={values.neck}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("LArm")}
                    name="lArm"
                    type="number"
                    placeholder="0.00"
                    value={values.lArm}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("RArm")}
                    name="rArm"
                    type="number"
                    placeholder="0.00"
                    value={values.rArm}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("NavelPoint")}
                    name="navelPoint"
                    type="number"
                    placeholder="0.00"
                    value={values.navelPoint}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("LNavelPoint")}
                    name="lNavelPoint"
                    type="number"
                    placeholder="0.00"
                    value={values.lNavelPoint}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("ThighL")}
                    name="thighL"
                    type="number"
                    placeholder="0.00"
                    value={values.thighL}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("ThighR")}
                    name="thighR"
                    type="number"
                    placeholder="0.00"
                    value={values.thighR}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("ShoulderRound")}
                    name="shoulder"
                    type="number"
                    placeholder="0.00"
                    value={values.shoulder}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("Chest")}
                    name="chest"
                    value={values.chest}
                    onChange={handleInpChg}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <Input
                    label={t("UpperAbs")}
                    name="upperAbs"
                    type="number"
                    placeholder="0.00"
                    value={values.upperAbs}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("UpperWaist")}
                    name="upperWaist"
                    type="number"
                    placeholder="0.00"
                    value={values.upperWaist}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("LowerWaist")}
                    name="lowerWaist"
                    type="number"
                    placeholder="0.00"
                    value={values.lowerWaist}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("LCalves")}
                    name="lCalves"
                    type="number"
                    placeholder="0.00"
                    value={values.lCalves}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("RCalves")}
                    name="rCalves"
                    type="number"
                    placeholder="0.00"
                    value={values.rCalves}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("BMI")}
                    name="bmi"
                    type="number"
                    placeholder="0.00"
                    value={values.bmi}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("BMR")}
                    name="bmr"
                    type="number"
                    placeholder="0.00"
                    value={values.bmr}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("VisceralFat")}
                    name="visceralFat"
                    type="number"
                    placeholder="0.00"
                    value={values.visceralFat}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Input
                    label={t("Subcutaneous Fat")}
                    name="subcutaneousFat"
                    type="number"
                    placeholder="0.00"
                    value={values.subcutaneousFat}
                    onChange={handleInpChg}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <MultiSelect
                    label={t("DoYouHave")}
                    name="healths"
                    value={values.healths}
                    error={errors.healths}
                    onChange={handleInpChg}
                    options={Healths}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Input
                    label={t("Remark")}
                    name="remarks"
                    inputProps={{ maxLength: 600 }}
                    value={values.remarks}
                    onChange={handleInpChg}
                    multiline
                    rows={2}
                  />
                </Grid>
              </Grid>
            </Tabs>
          </div>
        </Paper>
      </Form>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default AddEditMM;
